import React from "react"
import DefaultBtn from "./DefaultBtn"


export default class SendBtn extends React.Component {

  render() {
    return (
      <DefaultBtn 
      {...this.props}
      type="btn-send"
      />
    )
  }
}